module.exports = __webpack_public_path__ + "static/media/hero-guitar.9d4ed76f.jpg";